'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var appsConfig = process.env.NODE_ENV === 'production' ? require('./appsConfig.prod') : require('./appsConfig.dev');

module.exports = _extends({}, appsConfig, {
  BLOG_APP_ID: '14bcded7-0066-7c35-14d7-466cb3f09103',
  PAYWALL_APP_ID: '27125d23-126b-493a-bd7d-fc37eba188df',
  PAID_PLANS_APP_ID: '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3',
  PAID_PLANS_SECTION_ID: 'membership_plan_picker_tpa',
  SITE_MEMBERS_APP_ID: 'SiteMembers',
  MEMBERS_ABOUT_APP_ID: '14dbef06-cc42-5583-32a7-3abd44da4908',
  SEARCH_APP_ID: '1484cb44-49cd-5b39-9681-75188ab429de',
  MULTILINGUAL_APP_ID: '14d84998-ae09-1abf-c6fc-3f3cace5bf19'
});